export const name = 'xTwitter';

export const XTwitter = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    color="#161619"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
  >
    <path
      d="M18.244 2.25h3.309L14.325 10.509 22.828 21.75H16.172L10.955 14.934 4.992 21.75H1.678l7.73 -8.836L1.256 2.25h6.825l4.711 6.23zm-1.163 17.522h1.833L7.083 4.125h-1.969z"
      fill="currentColor"
    />
  </svg>
);
